import { getAxiosClient } from "../../axios-client";
import { PutAddressUpdateRequestBody, PutAddressUpdateUpdateResponse } from "./types";

const axiosClient = getAxiosClient();
export const putAddressUpdate = async (body: PutAddressUpdateRequestBody) => {
    return await axiosClient.ax.put<PutAddressUpdateUpdateResponse>("/Address/Update", body);
};
